import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import type { Office } from 'src/WebApiController';
import { OfficeClient } from 'src/WebApiController/office';

export const useOffices = () => {
  const { loginContext, activeAccountWebClientConfig } = useAppContext();

  const isOfficeEnabled =
    loginContext?.user?.activeAccount?.isOfficeEnabled === true;

  const queryKey = [
    'OfficeClient.getOffices',
    activeAccountWebClientConfig.activeAccountId,
  ];

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      if (!isOfficeEnabled) {
        return [];
      }
      return new OfficeClient(activeAccountWebClientConfig).getOffices();
    },
    enabled:
      isOfficeEnabled && activeAccountWebClientConfig.activeAccountId != null,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const defaultOffice: Office | null | undefined = query.data?.find(
    (o) => o?.isDefault
  );

  const getOfficeName = useCallback(
    (officeId: number | null | undefined): string | null => {
      if (officeId == null) return null;
      return (
        query.data?.find((o) => o?.officeId === officeId)?.officeName ?? null
      );
    },
    [query.data]
  );

  return { query, defaultOffice, getOfficeName, isOfficeEnabled };
};
